import { usePieChart } from "app/common/hooks/benchmark";
import Chart from "pro-features/components/Chart/src/Chart";
import type { TrafficShareMetricSchema } from "app/common/benchmark/types";
import { memo, useEffect, useRef } from "react";

type PieChartSchema = {
    primary: string;
    activeIndex?: number | null;
    trafficShareData: TrafficShareMetricSchema;
    sorted?: boolean;
    onPointHover?: (index: number) => void;
    onLeave?: () => void;
};

export const PieChart = memo(
    ({ primary, trafficShareData, activeIndex, sorted, onPointHover, onLeave }: PieChartSchema) => {
        const { chartData, chartConfig } = usePieChart({
            primary,
            activeIndex,
            trafficShareData,
            sorted,
            onPointHover,
        });

        const chartRef = useRef<HTMLElement | null>(null);

        const setChart = (ref: any) => {
            if (!ref) {
                return;
            }

            chartRef.current = ref.container?.current;
        };

        useEffect(() => {
            if (!chartRef.current || !onLeave) {
                return;
            }

            const container = chartRef.current;

            container.addEventListener("mouseleave", onLeave);

            return () => {
                container.removeEventListener("mouseleave", onLeave);
            };
        }, [onLeave]);

        return (
            <Chart
                data={chartData}
                config={chartConfig}
                setChart={setChart}
            />
        );
    },
);

PieChart.displayName = "PieChart";
